<template>
  <b-modal :active.sync="open" has-modal-card trap-focus width="1024px">
    <div style="min-width: 1024px; height: 700px">
      <l-map
          ref="map"
          :zoom="zoom"
          :center="currentCenter"
          :options="mapOptions"
          style="height: 500px"
      >
        <l-tile-layer
            :url="url"
            :attribution="attribution"
        />
        <l-marker v-for="marker in markers" :lat-lng="marker.latlng" :key="marker.id">
          <l-popup>
            <div>
              {{ marker.title }}
            </div>
          </l-popup>
        </l-marker>
        <l-polyline :lat-lngs="path" color="green"></l-polyline>
      </l-map>
    </div>
  </b-modal>
</template>

<script>
import {LMap, LTileLayer, LMarker, LPopup, LTooltip, LPolyline} from 'vue2-leaflet';
import {latLng} from "leaflet";
import {getAjax} from "@/funcs";

import {Icon} from 'leaflet';

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});


export default {
  name: "DeliveryReOrderMap",
  props: {
    addresses: Array,
    inPath: Array,
  },
  components: {LMap, LTileLayer, LMarker, LPopup, LTooltip, LPolyline},
  data() {
    return {
      url: this.$environment.production 
           ? `${this.$environment.backendURL.replace(/\/$/, '')}/osm/tiles/tile/{z}/{x}/{y}.png`
           : '/osm/tiles/{z}/{x}/{y}.png',
      attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      currentCenter: null,
      zoom: 15,
      mapOptions: {
        zoomSnap: 0.5
      },
      open: false,
    }
  },
  computed: {
    path() {
      if (this.inPath.length > 0) {
        return this.inPath
      } else {
        return this.markers.map((p => p.latlng))
      }
    },
    markers() {
      let arr = []
      this.addresses.forEach(address => {
        arr.push({
          latlng: latLng(address.locationLat, address.locationLon),
          title: address.street + ' ' + address.client.name,
        })
      })
      return arr
    }
  },
  methods: {},
  watch: {
    addresses() {
      this.open = true
      let address = this.addresses[0]
      this.currentCenter = latLng(address.locationLat, address.locationLon)
      setTimeout(() => {
        this.$refs.map.mapObject._onResize()
      }, 1000)
    }
  }
}
</script>

<style scoped>
.modal2 {
  display: block; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 1; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
}

/* Modal Content/Box */
.modal2-content {
  background-color: #fefefe;
  margin-top: 5vh;
  height: 90vh;
  margin-left: 5vw;
  padding: 20px;
  border: 1px solid #888;
  min-width: 1024px; /* Could be more or less, depending on screen size */
  max-width: 90vw;
  overflow-y: scroll;
}

</style>
